import { Component } from '@angular/core';
import { ModalContent, ModalRef } from '../../../modal-ref';
import { RestorationInstructionComponent } from '../../../../shared/components/restoration-instruction/restoration-instruction.component';

@Component({
    selector: 'app-restoration-instruction-modal',
    templateUrl: './restoration-instruction-modal.component.html',
    styleUrls: ['./restoration-instruction-modal.component.scss'],
    imports: [RestorationInstructionComponent]
})
export class RestorationInstructionModalComponent implements ModalContent {

  public modal: ModalRef;

}
